module.exports = __webpack_public_path__ + "static/media/wisebirdImage.46afda9f.svg";